var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6582 21.9083L15.4166 22.1583V15.8333C15.4166 15.3731 15.0435 15 14.5832 15C14.123 15 13.7499 15.3731 13.7499 15.8333V22.1583L13.5082 21.9083C13.1815 21.5816 12.6517 21.5816 12.3249 21.9083C11.9981 22.2351 11.9981 22.7649 12.3249 23.0917L13.9916 24.7583C14.0708 24.8342 14.1643 24.8937 14.2666 24.9333C14.4683 25.0225 14.6982 25.0225 14.8999 24.9333C15.0022 24.8937 15.0957 24.8342 15.1749 24.7583L16.8416 23.0917C17.053 22.8803 17.1355 22.5722 17.0581 22.2834C16.9808 21.9947 16.7552 21.7691 16.4665 21.6918C16.1777 21.6144 15.8696 21.697 15.6582 21.9083ZM19.5832 16.6667H27.9166C28.3768 16.6667 28.7499 16.2936 28.7499 15.8333C28.7499 15.3731 28.3768 15 27.9166 15H19.5832C19.123 15 18.7499 15.3731 18.7499 15.8333C18.7499 16.2936 19.123 16.6667 19.5832 16.6667ZM27.9166 19.1667H19.5832C19.123 19.1667 18.7499 19.5398 18.7499 20C18.7499 20.4602 19.123 20.8333 19.5832 20.8333H27.9166C28.3768 20.8333 28.7499 20.4602 28.7499 20C28.7499 19.5398 28.3768 19.1667 27.9166 19.1667ZM27.9166 23.3333H19.5832C19.123 23.3333 18.7499 23.7064 18.7499 24.1667C18.7499 24.6269 19.123 25 19.5832 25H27.9166C28.3768 25 28.7499 24.6269 28.7499 24.1667C28.7499 23.7064 28.3768 23.3333 27.9166 23.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/SortIcon.7d7ab74da4c065d6e7d962a85f19194a.svg";
export { ForwardRef as ReactComponent };